import { dayjs } from '@umanforge/common';
import * as dates from 'date-arithmetic';
import { useMemo } from 'react';
import { DateLocalizer, stringOrDate, ViewProps } from 'react-big-calendar';

// @ts-expect-error  'react-big-calendar/lib/TimeGrid' is export as any instead of TimeGrid
import TimeGrid from 'react-big-calendar/lib/TimeGrid';


export function CustomWeek( {
  date,
  localizer,
  max = localizer.endOf( dayjs().toDate(), 'day' ),
  min = localizer.startOf( dayjs().toDate(), 'day' ),
  scrollToTime = localizer.startOf( dayjs().toDate(), 'day' ),
  ...props
}: ViewProps ) {

  const currRange = useMemo(
    () => {
      return CustomWeek.range( date, { localizer } );
    }, [ date, localizer ]
  );

  return (
    <TimeGrid
      date={date}
      eventOffset={15}
      localizer={localizer}
      max={max}
      min={min}
      range={currRange}
      scrollToTime={scrollToTime}
      {...props}
    />
  );
}

CustomWeek.range = ( date: ( stringOrDate | undefined ) & stringOrDate, { localizer }: { localizer: DateLocalizer } ) => {
  const start = date;
  const end = dates.add( start as Date, 4, 'day' );

  let current = start;
  const range = [];

  while ( localizer.lte( current as Date, end, 'day' ) ) {
    range.push( current );
    current = localizer.add( current as Date, 1, 'day' );
  }

  return range;
};

CustomWeek.navigate = ( date: ( stringOrDate | undefined ) & stringOrDate ) => {return date;};
CustomWeek.title = () => { return ''; };



export function WeekViewWeekEnd( {
  date,
  localizer,
  max = localizer.endOf( dayjs().toDate(), 'day' ),
  min = localizer.startOf( dayjs().toDate(), 'day' ),
  scrollToTime = localizer.startOf( dayjs().toDate(), 'day' ),
  ...props
}: ViewProps ) {

  const currRange = useMemo(
    () => {
      return WeekViewWeekEnd.range( date, { localizer } );
    }, [ date, localizer ]
  );

  return (
    <TimeGrid
      date={date}
      eventOffset={15}
      localizer={localizer}
      max={max}
      min={min}
      range={currRange}
      scrollToTime={scrollToTime}
      {...props}
    />
  );
}

WeekViewWeekEnd.range = ( date: ( stringOrDate | undefined ) & stringOrDate, { localizer }: { localizer: DateLocalizer } ) => {
  const start = date;
  const end = dates.add( start as Date, 6, 'day' );

  let current = start;
  const range = [];

  while ( localizer.lte( current as Date, end, 'day' ) ) {
    range.push( current );
    current = localizer.add( current as Date, 1, 'day' );
  }

  return range;
};
WeekViewWeekEnd.navigate = ( date: ( stringOrDate | undefined ) & stringOrDate ) => {return date;};
WeekViewWeekEnd.title = () => { return ''; };



export function DayView( {
  date,
  localizer,
  max = localizer.endOf( dayjs().toDate(), 'day' ),
  min = localizer.startOf( dayjs().toDate(), 'day' ),
  scrollToTime = localizer.startOf( dayjs().toDate(), 'day' ),
  ...props
}: ViewProps ) {

  const currRange = useMemo(
    () => {
      return DayView.range( date, { localizer } );
    }, [ date, localizer ]
  );

  return (
    <TimeGrid
      date={date}
      eventOffset={15}
      localizer={localizer}
      max={max}
      min={min}
      range={currRange}
      scrollToTime={scrollToTime}
      {...props}
    />
  );
}

DayView.range = ( date: ( stringOrDate | undefined ) & stringOrDate, { localizer }: { localizer: DateLocalizer } ) => {
  const start = date;
  const end = dates.add( start as Date, 0, 'day' );

  let current = start;
  const range = [];

  while ( localizer.lte( current as Date, end, 'day' ) ) {
    range.push( current );
    current = localizer.add( current as Date, 1, 'day' );
  }

  return range;
};
DayView.navigate = ( date: ( stringOrDate | undefined ) & stringOrDate ) => {return date;};
DayView.title = () => { return ''; };